// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_header__mtodi {
	height: 6.87rem;
	width: 100vw;
	border-bottom: 0.0625rem solid white;

	display: flex;

	justify-content: space-between;
	align-items: center;

	padding: 0 10.31rem;

	position: absolute;
	top: 0;
}

.Header_burger__hide__92ccb {
	position: absolute;
	top: -27.0625rem;
	left: 0;
	width: 100vw;
	height: 27.0625rem;
	background: var(--accent-color, #875b52);
	transition: 0.3s all;
}

.Header_burger__show__Qb-Kf {
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 27.0625rem;
	background: var(--accent-color, #875b52);
	transition: 0.3s all;
}

.Header_logo__9YFPc {
	width: 9.875rem;
	height: 4.375rem;
}
.Header_header__links__q8SV9 {
	display: flex;
	gap: 1.88rem;
}

.Header_header__link__m4ycV {
	color: var(--text-color);
	font-family: 'Noto Sans';
	font-size: 1.3rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */

	cursor: pointer;
}

.Header_burger__menu__f8RrL {
	cursor: pointer;
	display: none;
}

.Header_burger__show__Qb-Kf {
	display: flex;
	flex-direction: column;
	/* display: none; */
}

.Header_burger__btn__cZo4F {
	position: absolute;
	right: 1.25rem;
	top: 1rem;
	cursor: pointer;
}

@media (max-width: 1440px) {
	.Header_header__link__m4ycV {
		color: var(--text-color);
		font-family: 'Noto Sans';
		font-size: 1rem;
		font-style: normal;
		font-weight: 400;
		line-height: 160%; /* 1.6rem */

		cursor: pointer;
	}
}

@media (max-width: 1440px) {
	.Header_logo__9YFPc {
		width: 7.875rem;
		height: 2.375rem;
	}
}

@media (max-width: 1280px) {
	.Header_header__mtodi {
		padding: 0 5rem;
	}
}

@media (max-width: 1000px) {
	.Header_header__link__m4ycV {
		display: none;
	}
	.Header_burger__menu__f8RrL {
		display: block;
	}
}

@media (max-width: 460px) {
	.Header_header__mtodi {
		padding: 0 1.25rem;
		border-bottom: none;
	}
	.Header_burger__show__Qb-Kf .Header_header__link__m4ycV {
		display: block;
		font-size: 1rem;
		font-style: normal;
		font-weight: 600;
		line-height: 160%; /* 1.5rem */
		text-decoration-line: underline;
	}
	.Header_burger__show__Qb-Kf {
		align-items: center;
		justify-content: center;
		text-align: center;
		gap: 3rem;
	}
	.Header_header__links__q8SV9 {
		flex-direction: column;
		gap: 0.8rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,YAAY;CACZ,oCAAoC;;CAEpC,aAAa;;CAEb,8BAA8B;CAC9B,mBAAmB;;CAEnB,mBAAmB;;CAEnB,kBAAkB;CAClB,MAAM;AACP;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,OAAO;CACP,YAAY;CACZ,kBAAkB;CAClB,wCAAwC;CACxC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,YAAY;CACZ,kBAAkB;CAClB,wCAAwC;CACxC,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;CACC,wBAAwB;CACxB,wBAAwB;CACxB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,aAAa;AACd;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,SAAS;CACT,eAAe;AAChB;;AAEA;CACC;EACC,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;;EAE9B,eAAe;CAChB;AACD;;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,aAAa;CACd;CACA;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,+BAA+B;CAChC;CACA;EACC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;CACV;CACA;EACC,sBAAsB;EACtB,WAAW;CACZ;AACD","sourcesContent":[".header {\n\theight: 6.87rem;\n\twidth: 100vw;\n\tborder-bottom: 0.0625rem solid white;\n\n\tdisplay: flex;\n\n\tjustify-content: space-between;\n\talign-items: center;\n\n\tpadding: 0 10.31rem;\n\n\tposition: absolute;\n\ttop: 0;\n}\n\n.burger__hide {\n\tposition: absolute;\n\ttop: -27.0625rem;\n\tleft: 0;\n\twidth: 100vw;\n\theight: 27.0625rem;\n\tbackground: var(--accent-color, #875b52);\n\ttransition: 0.3s all;\n}\n\n.burger__show {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100vw;\n\theight: 27.0625rem;\n\tbackground: var(--accent-color, #875b52);\n\ttransition: 0.3s all;\n}\n\n.logo {\n\twidth: 9.875rem;\n\theight: 4.375rem;\n}\n.header__links {\n\tdisplay: flex;\n\tgap: 1.88rem;\n}\n\n.header__link {\n\tcolor: var(--text-color);\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.3rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n\n\tcursor: pointer;\n}\n\n.burger__menu {\n\tcursor: pointer;\n\tdisplay: none;\n}\n\n.burger__show {\n\tdisplay: flex;\n\tflex-direction: column;\n\t/* display: none; */\n}\n\n.burger__btn {\n\tposition: absolute;\n\tright: 1.25rem;\n\ttop: 1rem;\n\tcursor: pointer;\n}\n\n@media (max-width: 1440px) {\n\t.header__link {\n\t\tcolor: var(--text-color);\n\t\tfont-family: 'Noto Sans';\n\t\tfont-size: 1rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 160%; /* 1.6rem */\n\n\t\tcursor: pointer;\n\t}\n}\n\n@media (max-width: 1440px) {\n\t.logo {\n\t\twidth: 7.875rem;\n\t\theight: 2.375rem;\n\t}\n}\n\n@media (max-width: 1280px) {\n\t.header {\n\t\tpadding: 0 5rem;\n\t}\n}\n\n@media (max-width: 1000px) {\n\t.header__link {\n\t\tdisplay: none;\n\t}\n\t.burger__menu {\n\t\tdisplay: block;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.header {\n\t\tpadding: 0 1.25rem;\n\t\tborder-bottom: none;\n\t}\n\t.burger__show .header__link {\n\t\tdisplay: block;\n\t\tfont-size: 1rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 160%; /* 1.5rem */\n\t\ttext-decoration-line: underline;\n\t}\n\t.burger__show {\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\ttext-align: center;\n\t\tgap: 3rem;\n\t}\n\t.header__links {\n\t\tflex-direction: column;\n\t\tgap: 0.8rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__mtodi`,
	"burger__hide": `Header_burger__hide__92ccb`,
	"burger__show": `Header_burger__show__Qb-Kf`,
	"logo": `Header_logo__9YFPc`,
	"header__links": `Header_header__links__q8SV9`,
	"header__link": `Header_header__link__m4ycV`,
	"burger__menu": `Header_burger__menu__f8RrL`,
	"burger__btn": `Header_burger__btn__cZo4F`
};
export default ___CSS_LOADER_EXPORT___;
